module.exports = __webpack_public_path__ + "static/media/item_sli_semantic_des.f2bfed00.png";